import { h, Component } from "preact";
import style from "./style.scss";

export default class SectionContainer extends Component {
    static defaultProps = {
        justifyContent: 'center',
        flex: 1
    };

    render(props, state, context) {
        return (
            <div className={style.sectionContainer} style={props.style}>
                {props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/layout/section-container/index.js